import React, {useEffect, useState} from 'react'
import {ReactFlowProvider} from 'reactflow'
import FlowCanvas from './FlowCanvas/FlowCanvas'
import {useParams} from 'react-router-dom'
import {useGetFlowQuery} from '../../../../../services/cellcast.v2'
import {Spinner} from 'react-bootstrap'
import {Flow} from './FlowTypes'
import {useI18n} from '../../../../Utils/_helpers/useI18n'

const WorkFlowContent: React.FC<{payload?: Flow; isEdit: boolean}> = ({payload, isEdit}) => {
  return (
    <div className='container-fluid h-100'>
      <div className='row bg-white h-100'>
        <FlowCanvas payload={payload} isEdit={isEdit} />
      </div>
    </div>
  )
}

const WorkFlow: React.FC = () => {
  const {t} = useI18n()
  const {id} = useParams<{id: string}>()

  const {
    data: flow,
    isLoading,
    error,
  } = useGetFlowQuery(
    {id: id as string},
    {
      refetchOnMountOrArgChange: true,
      skip: !id,
      refetchOnFocus: true,
    }
  )

  const isEdit = Boolean(id)

  if (isLoading) {
    return (
      <div className='row flex-center h-200'>
        <Spinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className='row flex-center h-200'>
        <div className='error-message'>{t('FLOW.WORKFLOW.ERROR')}</div>
      </div>
    )
  }

  return (
    <ReactFlowProvider>
      <WorkFlowContent payload={flow?.data} isEdit={isEdit} />
    </ReactFlowProvider>
  )
}

export default WorkFlow
